@if(showHistory){
<div class="relative">
    <div class="flex gap-2 items-center justify-end p-2 h-10">
        <div pRipple class="justify-end" (click)="chatStarting ? null : historyPanel.toggle($event)">
            <i class="pi pi-history p-2 rounded-full text-white bg-arena-orange-800 cursor-pointer"></i>
        </div>
    </div>
</div>
}

<div class="inn-flex-container flex flex-col justify-between relative">
    <div class="chat-section inn-flex-scroll flex-1" #scrollBottom>
        @if(showSuggestions){
        <div class="prompt-container" [ngClass]="{'empty-doc-restrict' : isEmptyDoc}">
            <!-- Bot Icon -->
            <div class="bot-icon">
                <img [src]="'images/bob_agent/bob.svg' | assetUrl" alt="Bot Icon" />
            </div>

            <!-- Title -->
            <p class="title"> {{"Get started with these prompts" | titlecase}}</p>

            <!-- Prompt Buttons -->
            <div
                class="flex justify-start items-center overflow-x-auto whitespace-nowrap mt-4 w-full scroll-smooth snap-x snap-mandatory no-scrollbar">
                @for (question of promptQuestions; track $index) {
                <div class="cursor-pointer border border-gray-300 rounded-full text-xs text-center bg-white z-10 font-semibold justify-center p-2 items-center mx-1 snap-start"
                    [ngClass]="{'pointer-events-none' : isEmptyDoc}" (click)="prompt = question; sendPrompt()">
                    {{ question }}
                </div>
                }
            </div>

        </div>
        }
        @if(!showSuggestions){
        <div class="mt-4">
            @for (conversation of conversations; track $index) {
            <app-ai-chat-bubble class="w-full" [Chat]="conversation"></app-ai-chat-bubble>
            }
        </div>
        }
        @if(isEmptyDoc) {
        <div class="absolute inset-0 flex items-center justify-center z-10">
            <div
                class="group relative p-2 border rounded-full shadow-xl flex items-center justify-center text-center bg-white transition-all duration-300 hover:shadow-2xl cursor-pointer">
                <i class="pi pi-lock transition-transform duration-300 group-hover:scale-110"></i>
                <div
                    class="absolute top-[-2.5rem] left-1/2 transform -translate-x-1/2 bg-black text-white text-xs px-3 py-1 rounded opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition-all duration-300 whitespace-nowrap">
                    No Insights generated yet!
                </div>
            </div>
        </div>
        }
    </div>
    <div class="justify-end bg-transparent" #promptInput id="promptInput"
        [ngClass]="{'empty-doc-restrict' : isEmptyDoc}">
        @if(showLimitWarning){
        <div
            class="bg-orange-50  border-b  border-t border-gray-200 text-sm text-arena-orange-800 px-3 py-2 flex justify-between items-center ">
            <span class="text-xs"><span class="px-[0.1rem] rounded-full bg-arena-orange-800  mr-1"></span>Tip: Long
                chats may
                cause you to
                reach your usage limits faster.</span>
            <a href="#" class="text-arena-orange-800  text-xs font-semibold" (click)="startNewConversation()">New
                chat</a>
            <i class="pi pi-times-circle cursor-pointer" (click)="showLimitWarning=false"></i>
        </div>
        }
        @if(showTags){
        @if(this.showTagsPanel){
        <!-- <div class="p-3 bg-transparent identifiers">
            <p-panelMenu [model]="identifiers" [multiple]="true" class="w-[60%] md:w-20rem rounded-base border " />
        </div> -->

        <div *ngIf="!selectedIdentifier" class="p-3 identifiers">
            <div class="w-[60%] md:w-80 border rounded-base p-4 bg-white shadow-lg">
                <h3 class="text-sm font-semibold mb-2">Identifiers</h3>
                <ul class="list-none p-0 m-0">
                    <li *ngFor="let identifier of identifiers"
                        class="cursor-pointer my-2 py-2 px-3 border rounded-base  hover:bg-gray-100"
                        (click)="selectIdentifier(identifier)">
                        <div class="flex justify-between items-center">
                            <span class="text-sm">{{ identifier.label }}</span>
                            <i class="pi pi-chevron-right text-sm"></i>
                        </div>
                    </li>
                    <hr class="my-2">
                    @for (option of toggleOptions; track $index) {
                    <div class="flex justify-between items-center cursor-pointer mb-2 p-2"
                        (click)="selectToggleOption(option)">
                        <div class="flex items-center">
                            <i class="{{option.icon}} text-sm mr-2"></i>
                            <span class="text-sm">{{option.label}}</span>
                        </div>
                        <div class="flex items-center">
                            <label class="inline-flex items-center cursor-pointer" (click)="$event.stopPropagation()">
                                <input type="checkbox" value="" class="sr-only peer"
                                    [checked]="selectedToggleOption.includes(option)"
                                    (click)="selectToggleOption(option)">
                                <div (click)="$event.stopPropagation()"
                                    class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600">
                                </div>
                            </label>
                        </div>
                    </div>
                    }
                </ul>
            </div>
        </div>


        <div *ngIf="selectedIdentifier" class="p-3 identifiers">
            <div class="w-[60%] md:w-80 border rounded-base p-4 bg-white shadow-lg">
                <div class="flex items-center mb-4">
                    <button class=" p-1    mr-2" (click)="deselectIdentifier()">
                        <div class="flex gap-2 items-center">
                            <i class="pi pi-arrow-left text-sm"></i>
                            <!-- <span>Back</span> -->
                        </div>
                    </button>
                    <span class="text-sm font-semibold">
                        {{ selectedIdentifier.label }}
                    </span>
                </div>

                <input type="text" [(ngModel)]="searchText"
                    placeholder="{{'Search for' | titlecase}} {{ selectedIdentifier.label }}"
                    class="w-full p-2 mb-3 border rounded-base text-sm focus:outline-none focus:ring-2 focus:ring-orange-500" />


                <ul class="list-none p-0 m-0 max-h-60 overflow-auto flex flex-col gap-2">
                    <li *ngFor="let item of getFilteredItems()"
                        (click)="item.command?.({originalEvent: $event, item: item})"
                        class="cursor-pointer py-2 px-3 border hover:bg-gray-100 rounded-base">
                        <span class="text-sm">{{ item.label }}</span>
                    </li>
                    @if(getFilteredItems().length == 0){
                    <span class="text-center">No {{ selectedIdentifier.label }} found.</span>
                    }
                </ul>
            </div>
        </div>

        }
        }

        @if(showOptions){
        @if(this.showOptionsPanel){
        <div class="p-3 options-panel">
            <div class="w-[100%] md:w-40rem rounded-base border p-2 bg-white shadow-lg">
                @for (item of options; track $index) {
                <div class="flex gap-2 items-center p-2 cursor-pointer mb-1 rounded-base" [ngClass]="{
                            'bg-arena-blue-100 border border-arena-blue-200 hover:bg-arena-blue-100': selectedOptions.includes(item),
                            'hover:bg-gray-200': !selectedOptions.includes(item)
                        }" (click)="selectOption(item)">
                    <span>
                        <i class="{{item.icon}} text-lg"></i>
                    </span>
                    <div class="flex flex-col">
                        <span class="text-md font-medium">{{item.label}}</span>
                        <span class="text-xs text-gray-500">{{item.description}}</span>
                    </div>
                </div>
                }

            </div>
        </div>
        }
        }

        @if(tags.length > 0 || ( selectedOptions &&
        selectedOptions.length>0)) {
        <div class="flex flex-wrap p-2 gap-1 items-center">
            @for (item of selectedOptions; track $index) {
            <div
                class="flex gap-1 items-center rounded-full bg-arena-blue-100 py-0.5 px-2.5  text-sm text-arena-blue-700 font-bold shadow-sm">
                <i class="{{item.icon}} text-xs"></i>
                <span>{{item.label}}</span>
                <i class="mr-1 pi pi-times-circle cursor-pointer" (click)="removeOption(item)"></i>
            </div>
            }
            @for (item of tags; track $index) {
            <div
                class="flex gap-1 items-center rounded-full bg-arena-orange-100 py-0.5 px-2.5  text-sm text-arena-orange-700 font-bold shadow-sm">
                @if(chatSource == "CONTRACT"){
                <i class="pi pi-link text-xs"></i>
                }
                @else {
                <i class="pi pi-chart-bartext-xs"></i>
                }
                <span>{{item.label}}</span>
                <i class="mr-1 pi pi-times-circle cursor-pointer" (click)="removeTag(item)"></i>
            </div>
            }

        </div>
        }

        <div class="flex flex-col fixed-actions no-scroll gap-2">
            <div class="flex flex-col  prompt border-t-gray-200">
                <div class="flex items-center">
                    <span class="svg-icon ml-2 stars" [innerHTML]="icons.AI_CHAT_STARS | sanitizeHtml"></span>
                    <input type="text" placeholder="{{'Type Something ...' | titlecase}}" [maxlength]="maxPromptLength"
                        [(ngModel)]="prompt" [disabled]="isCurrentConversationLoading" (input)="checkPromptLength()"
                        (keydown.enter)="sendPrompt()" class=" w-full promptInput">
                    @if (!isCurrentConversationLoading) {
                    <span
                        [ngClass]="{'disabled-svg': isCurrentConversationLoading || promptLength<1 , 'send' : !isCurrentConversationLoading || promptLength>1}"
                        class="svg-icon mr-2" [innerHTML]="icons.CHAT_BOT_SEND | sanitizeHtml"
                        (click)="sendPrompt()"></span>
                    }
                    @if (isCurrentConversationLoading) {
                    <span class="loader mr-2"></span>
                    }
                </div>
                <div class="flex gap-2 p-1 ">
                    @if(showTags){
                    <i class="border p-2 cursor-pointer rounded-full inline-flex items-center justify-center bg-gray-200 text-sm"
                        [pTooltip]="showTagsPanel ? 'Identifiers Panel is active' : 'Click to open Identifiers Panel'"
                        tooltipPosition="top" (click)="showTagsPanel = !showTagsPanel ; showOptionsPanel = false"
                        [ngClass]="{'border-orange-200': showTagsPanel , 'bg-orange-100' : showTagsPanel}">
                        <span class="pi pi-at text-sm"></span>
                    </i>
                    }
                    @if(showOptions){
                    <i class="border p-2 cursor-pointer rounded-full inline-flex items-center justify-center bg-gray-200 text-sm"
                        [pTooltip]="showOptionsPanel ? 'Output Options Panel is active' : 'Click to open Output Options Panel'"
                        tooltipPosition="top"
                        [ngClass]="{'border-orange-200': showOptionsPanel , 'bg-orange-100' : showOptionsPanel}"
                        (click)=" showOptionsPanel=!showOptionsPanel ; showTagsPanel=false">
                        <span class="pi pi-ellipsis-h text-sm"></span>
                    </i>
                    }
                    @if(agentModeFeatureVisible){
                    <i class="border p-2 cursor-pointer rounded-full inline-flex items-center justify-center bg-gray-200 text-sm"
                        [ngClass]="{'border-orange-200': agentModeEnabled , 'bg-orange-100' : agentModeEnabled}"
                        [pTooltip]="agentModeEnabled ? 'Agent Mode is active for this conversation' : 'Enable Agent Mode for deeper analysis'"
                        tooltipPosition="top" (click)="onAgentModeToggle(!agentModeEnabled)">
                        <span>Agent</span>
                    </i>
                    }
                </div>
            </div>
            <div class="flex justify-between gap-1 ml-3 mr-3 info">
                <div class="w-full text-xs">
                    This Assistant provides automated responses that should be reviewed for correctness
                </div>
                <div>
                    @if (promptLength >= maxPromptLength) {
                    <div class="text-sm text-danger">
                        {{promptLength}}/{{maxPromptLength}} (Maximum reached)
                    </div>
                    }
                    @if (promptLength < maxPromptLength) { <div>
                        {{promptLength}}/{{maxPromptLength}}
                </div>
                }

            </div>
        </div>
    </div>
</div>

<app-popover #historyPanel [width]="'24rem'" [maxHeight]="'30rem'" [showScrollbar]="true">
    <ng-template #trigger>
        <!-- trigger is driven programmatically via historyPanel.toggle(); this slot is intentionally empty -->
    </ng-template>
    <ng-template #body>
        <div class="flex flex-col gap-2 p-2 overflow-y-auto" style="max-height: 25rem;">
            <div class="my-3 items-center">
                <app-search-bar placeholder="Search a conversation" (ngModelChange)="searchConversations($event)"
                    width="100%"></app-search-bar>
            </div>
            @for (history of conversationsHistory; track $index) {
            @if (history.length != 0) {
            <span class="text-xs">{{$index == 0 ? 'Today' : $index == 1 ? 'Last 7 days' : 'Last 30 Days'}}</span>
            @for (item of history; track $index) {
            <div class="rounded-base hover:bg-gray-200 p-2 cursor-pointer flex  justify-between items-center"
                [ngClass]="{'bg-orange-200': selectedConversation == item._id}"
                (click)="enableRename && enableRename._id == item._id ? null : getMessages(item._id ,historyPanel , $event)">
                @if(enableRename && enableRename._id == item._id){
                <span #editableContent scrollReset [attr.contenteditable]="true"
                    (click)="enableRename = item; $event.stopPropagation();"
                    class="text-sm mx-3 max-w-[25rem] whitespace-nowrap overflow-x-auto inline-block no-scrollbar"
                    (keydown)="$event.key === 'Enter' ? blurSpan($event) : null"
                    (blur)="updateConversationName($event,item)">
                    {{item.name}}
                </span>
                }
                @else{
                <div class="flex flex-col gap-1">
                    <span>{{item.name | truncate:30}}</span>
                    <span class="text-xs text-gray-500">{{item.createdAt |date }}</span>
                </div>

                }
                <div>
                    <app-popover #historyOptions [width]="'10rem'">
                        <ng-template #trigger>
                            <i class="pi pi-ellipsis-v cursor-pointer" (click)="historyOptions.toggle();$event.stopPropagation()"></i>
                        </ng-template>
                        <ng-template #body>
                            <div class="flex flex-col gap-1 rounded-base justify-center">
                                <div class="hover:bg-gray-200 p-1 cursor-pointer flex gap-2 items-center rounded-base"
                                    (click)="renameChatHistory(item);historyOptions.hide()">
                                    <i class="pi pi-pencil"></i>
                                    <span class="hover:bg-gray-200 rounded-base">Rename</span>
                                </div>
                                <div class="hover:bg-gray-200 p-1 cursor-pointer gap-2 flex items-center rounded-base"
                                    (click)="deleteConversation(item);historyOptions.hide()">
                                    <i class="pi pi-trash text-danger"></i>
                                    <span class=" hover:bg-gray-200 rounded-base text-danger">Delete</span>
                                </div>
                            </div>
                        </ng-template>
                    </app-popover>
                </div>

            </div>
            }
            }
            }
            @if(!conversationsHistory || conversationsHistory.length == 0 || conversationsHistory[0].length == 0 &&
            conversationsHistory[1].length ==
            0 && conversationsHistory[2].length == 0 ){
            <div class="text-center text-sm">No Conversations</div>
            }
        </div>

        <div class="p-2 items-center justify-center flex">
            <app-button label="New Chat" variant="filled" icon="pi pi-plus" [loading]="chatStarting" severity="primary"
                (clicked)="startNewConversation();historyPanel.hide()" iconPosition="left" />
        </div>
    </ng-template>
</app-popover>